import React from "react";
import DetalleAventura from "./aventuras/detalleaventura";
import MenuEscritorio from "./componenteshome/MenuEscritorio";
import FooterMenu from "./componenteshome/footer";

export default function Veraventura() {
  return (
    <div>
      <DetalleAventura />
      <MenuEscritorio />
      <FooterMenu />
    </div>
  );
}
